import { render, staticRenderFns } from "./CkSkeletonLoader.vue?vue&type=template&id=48c8592c&scoped=true&"
import script from "./CkSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./CkSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./CkSkeletonLoader.vue?vue&type=style&index=0&id=48c8592c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c8592c",
  null
  
)

export default component.exports